<cb-spaces
	id="spaces-menu"
	[optionsList]="optionsList">
	{{'header.spacesMenuTitle'|i18n}}
</cb-spaces>